// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const DownloadIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        d="M17.83 7.06c2.58 0 4.67 2.16 4.67 4.82v5.29c0 2.65-2.09 4.8-4.66 4.8H6.17c-2.57 0-4.67-2.16-4.67-4.81v-5.29c0-2.65 2.1-4.8 4.66-4.8h11.67"
        opacity=".5"
      />
      <path d="m12.57 16.24 3.06-3.12c.31-.32.31-.84 0-1.16-.32-.32-.83-.32-1.15 0l-1.67 1.71V2.85c0-.46-.36-.83-.81-.83s-.8.37-.8.83v10.82l-1.68-1.7c-.32-.33-.83-.33-1.14 0q-.24.24-.24.57t.23.58l3.06 3.12q.24.23.57.24.34 0 .57-.24" />
    </g>
  </SvgIcon>
);

export default DownloadIcon;
